import { ApiEndpoints } from './endpoints';
import axios from 'axios';
import { BASE_URL } from './service';

// export const refreshToken = async () => {
//     let refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
//     let body = { refresh_token };

//     try {
//         const conf = {
//             headers: {
//                 'Access-Control-Allow-Origin': '*',
//                 'Content-Type': 'application/json',
//             },
//         };

//         const response = await axios.post(`${BASE_URL}${ApiEndpoints.REFRESHTOKEN}`, body, conf);
//         const newToken = JSON.stringify(response.data.data.access_token);
//         localStorage.setItem('token', newToken);
//         apiService.service.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
//         return newToken;
//     } catch (error) {
//         // eslint-disable-next-line no-unused-vars
//         const message = error.response ? error.response.data.message : 'Network Error';
//         localStorage.removeItem('token');
//         localStorage.removeItem('refresh_token');
//         return null;
//     }
// };
export const refreshToken = async () => {
    const refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
    if (!refresh_token) return null;

    try {
        const response = await axios.post(
            `${BASE_URL}${ApiEndpoints.REFRESHTOKEN}`,
            { refresh_token },
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            },
        );

        const access_token = response.data.data.access_token;
        localStorage.setItem('token', JSON.stringify(access_token));

        return access_token;
    } catch (error) {
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        return null;
    }
};

export const logoutUser = async () => {
    let refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
    let body = { refresh_token: refresh_token };
    if (refresh_token) {
        try {
            const conf = {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                },
            };
            localStorage.removeItem('token');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');

            await axios.delete(`${BASE_URL}${ApiEndpoints.LOGOUT}`, { data: body }, conf);
            window.location.reload();
        } catch (error) {
            // eslint-disable-next-line no-unused-vars
            const message = error.response ? error.response.data.message : 'Network Error';
        }
    } else {
        localStorage.removeItem('token');
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
    }
};
